import React, { useEffect, useState } from "react";
import closeIcon from "../../assets/icons/x-circle.svg";
import Modal from "react-bootstrap/Modal";
import { Col, Row } from "react-bootstrap";
import "../../assets/styles/local/WorkflowAutomation.css";
import { FetchFormListForWorkflow } from "../../redux/actions/action";

import { useDispatch, useSelector } from "react-redux";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const FormSelectionModel = (props) => {
  const dispatch = useDispatch();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    dispatch(FetchFormListForWorkflow());
  }, []);

  const formList = useSelector((state) => state.user.workflowFormList);

  const [formOption, setFormOption] = useState([
    {
      //   label: "Select Form name",
      label: t("Select form name"),
      value: "",
      disabel: true,
    },
  ]);

  useEffect(() => {
    if (
      formList &&
      formList.status &&
      formList.data &&
      formList.data.length > 0
    ) {
      let formListData = formList.data.map((o) => {
        return {
          label: o.formName,
          value: o.formId,
          disabel: false,
        };
      });

      setFormOption([
        {
          //   label: "Select Form name",
          label: t("Select form name"),
          value: "",
          disabel: true,
        },
        ...formListData,
      ]);
    }
  }, [formList]);

  const [selectedForm, setSelectedForm] = useState({
    formId: "",
    formName: "",
  });

  return (
    <>
      <style jsx>{`
        #formName .modal-content {
          background: #fff;
        }
      `}</style>
      <Modal
        id="formName"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="form-name-select p-5"
        centered
      >
        <Row>
          <Col>
            <strong>
              {/* Form Name */}
              {t("Form Name")}
            </strong>
          </Col>
          <Col className="d-flex justify-content-end pe-0">
            <img
              className="cursor-pointer close-btn"
              src={closeIcon}
              alt=""
              onClick={() => {
                props.close();
              }}
            />
          </Col>
        </Row>

        <div className="text-center mt-2">
          {/* Form Selection  */}
          <div className="workflow_input_wrap mt-4" style={{ marginBottom: 0 }}>
            <label className="workflow_form_label">
              {/* Form */}
              {t("Form")}
            </label>
            <div className="input_wrap">
              <select
                className="cursor-pointer"
                onChange={(e) => {
                  let _formOption = formOption.find(
                    (o) => o.value === e.target.value,
                  );
                  setSelectedForm({
                    formId: _formOption.value,
                    formName: _formOption.label,
                  });
                }}
              >
                {formOption.length &&
                  formOption.map((o) => (
                    <option
                      value={o.value}
                      disabled={o.disabel}
                      selected={o.disabel}
                      hidden={o.disabel}
                    >
                      {o.label}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
          <button
            className="select-form-name-btn p-2"
            disabled={selectedForm.formId == ""}
            onClick={() => {
              props.select(selectedForm);
            }}
          >
            {/* Select */}
            {t("Select ")}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default FormSelectionModel;
